import ApiResourceManager from '../ApiResourceManager';

export default class PhoneAnsweringManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/phone-answering',
    });

  update = (data) =>
    this.request({
      method: 'PUT',
      url: 'phone-answering',
      data,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: 'phone-answering',
      data,
    });

  getPhoneNumbers = (params) =>
    this.request({
      method: 'GET',
      url: 'phone-answering/occ-phone-numbers',
      params,
    });
}
